<template>
  <div class="ct-toolbar" aria-label="Selección de protocolo">
    <div class="ct-toolbar-selects">
      <slot name="toolbar-extra" />

      <div class="ct-select-chip">
        <label :for="ids.profession">Profesión</label>
        <select
          :id="ids.profession"
          class="ct-toolbar-select"
          :value="professionId"
          @change="onProfessionChange"
        >
          <option
            v-for="profession in professions"
            :key="profession.id"
            :value="profession.id"
          >
            {{ profession.label }}
          </option>
        </select>
      </div>

      <div class="ct-select-chip">
        <label :for="ids.test">Test</label>
        <select
          :id="ids.test"
          ref="testSelect"
          class="ct-toolbar-select"
          :class="{ 'ct-guide-blink': highlightTestSelect }"
          :value="testSlug"
          @change="onTestChange"
        >
          <option
            v-for="test in availableTests"
            :key="test.slug"
            :value="test.slug"
            :disabled="isTestOptionDisabled(test)"
          >
            {{ testOptionLabel(test) }}
          </option>
        </select>
      </div>

      <div v-if="showAge" class="ct-select-chip ct-age-chip">
        <label :for="ids.age">{{ ageLabel }}</label>
        <select
          :id="ids.age"
          class="ct-toolbar-select"
          :class="{
            'is-empty': !age,
            'ct-guide-blink': highlightAge,
          }"
          :value="age"
          @mousedown="onAgeInteract"
          @focus="onAgeInteract"
          @change="onAgeChange"
        >
          <option value="">{{ agePlaceholder }}</option>
          <option
            v-for="opt in ageOptions"
            :key="opt.value"
            :value="opt.value"
          >
            {{ opt.label }}
          </option>
        </select>
      </div>
    </div>

    <div class="ct-action-row">
      <p v-if="blockedHint" class="ct-blocked-hint">{{ blockedHint }}</p>
      <!-- Junto al botón que gasta el uso, no arriba entre los selects: es el
           lugar donde el dato todavía puede cambiar una decisión. -->
      <span
        v-if="usesChip"
        class="ct-uses-chip"
        :class="`is-${usesChip.tone}`"
        :title="
          usesChip.tone === 'paid'
            ? 'Tu colegio tiene contrato vigente: las correcciones no gastan usos.'
            : 'Cada test corregido descuenta un uso.'
        "
      >
        {{ usesChip.tone === "paid" ? "✨" : "🎟️" }} {{ usesChip.label }}
      </span>
      <button
        ref="primaryBtn"
        type="button"
        class="ct-direct-btn"
        :disabled="primaryDisabled || primaryLoading"
        @click="$emit('primary-action')"
      >
        {{ primaryLoading ? "Corrigiendo…" : primaryLabel }}
      </button>
    </div>
  </div>
</template>

<script>
import {
  getProfessions,
  getTestsForProfession,
} from "../constants/testCatalog";

let toolbarUid = 0;

export default {
  name: "TestToolbar",
  props: {
    professionId: { type: String, required: true },
    testSlug: { type: String, required: true },
    age: { type: String, default: "" },
    ageOptions: { type: Array, default: () => [] },
    showAge: { type: Boolean, default: false },
    // El CARAS-R usa este selector para el curso y el baremo, no para la edad.
    ageLabel: { type: String, default: "Edad" },
    agePlaceholder: { type: String, default: "Selecciona la edad" },
    primaryLabel: { type: String, default: "Corregir test" },
    primaryDisabled: { type: Boolean, default: true },
    primaryLoading: { type: Boolean, default: false },
    highlightAge: { type: Boolean, default: false },
    highlightTestSelect: { type: Boolean, default: false },
    session: { type: Object, required: true },
    blockedHint: { type: String, default: "" },
    // { label, tone } de serviceUses.usesChip, o null cuando no hay nada
    // honesto que decir (sin sesión, o saldo desconocido). El toolbar no lo
    // calcula: lo arma el workspace, que es quien conoce el servicio.
    usesChip: { type: Object, default: null },
    // Dentro del colegio (el workspace lo pasa desde requireStudent). Habilita
    // las profesiones platformOnly, que en el producto gratis no se ofrecen.
    platform: { type: Boolean, default: false },
  },
  data() {
    toolbarUid += 1;
    return {
      ids: {
        profession: `ct-profession-${toolbarUid}`,
        test: `ct-test-${toolbarUid}`,
        age: `ct-age-${toolbarUid}`,
      },
    };
  },
  computed: {
    professions() {
      return getProfessions(this.platform);
    },
    availableTests() {
      return getTestsForProfession(this.professionId);
    },
  },
  methods: {
    onProfessionChange(event) {
      this.$emit("update:professionId", event.target.value);
    },
    onTestChange(event) {
      this.$emit("update:testSlug", event.target.value);
    },
    onAgeChange(event) {
      this.$emit("update:age", event.target.value);
    },
    onAgeInteract() {
      this.$emit("age-interact");
    },
    isTestOptionDisabled(test) {
      return this.session.isBlocked(test.value);
    },
    testOptionLabel(test) {
      const corrected = this.session.isCorrected(test.value);
      const blocked = this.session.isBlocked(test.value);
      if (corrected) return test.label + " · corregido";
      if (blocked) return test.label + " (no combinable)";
      return test.label;
    },
    getPrimaryButtonEl() {
      return this.$refs.primaryBtn;
    },
    getTestSelectEl() {
      return this.$refs.testSelect;
    },
  },
};
</script>
